export default __webpack_public_path__ + "static/media/choice_cycle.8a06b65f.png";